import { Box, InputAdornment, TextField, useMediaQuery } from '@mui/material'
import { SOCIAL_NETWORKS } from 'Components/ProfileComponents/SettingsForm/constants'
import FAIcon from 'Theme/FAIcon'
import { BREAKPOINT_MIN_LG } from 'Theme/stylesUtil'

export const JudgesSocialNetworks = ({ judge, handleChange }) => {
  const isBiggerThanLGScreen = useMediaQuery(BREAKPOINT_MIN_LG)

  const widthMedium = isBiggerThanLGScreen ? 338 : '100%'

  return (
    <Box
      display="flex"
      flexWrap="wrap"
      gap={3}
    >
      {SOCIAL_NETWORKS.map((item) => (
        <Box
          key={item.name}
          width={widthMedium}
        >
          <TextField
            placeholder={item.placeholder}
            onChange={(e) => handleChange(e.target.value, item.name)}
            value={judge.profile?.[item.name] || ''}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <FAIcon
                    iconFontSize={14}
                    iconClassName={item.icon}
                  />
                </InputAdornment>
              ),
            }}
          />
        </Box>
      ))}
    </Box>
  )
}
